export const ALIAS_GESTIONES = "AP_MODULO_GESTIONES";
export const ALIAS_OTRAS_GESTIONES = "AP_MODULO_OTRAS_GESTIONES";
export const ALIAS_OTRAS_GESTIONES_NEW = "AP_MODULO_OTRAS_GESTIONES";
export const ALIAS_FOOTER_MANAGMENT = "AP_MODULO_FOOTER";
export const ALIAS_SERVICIOS_GRATUITOS = "AP_MODULO_SERVICIOS_GRATUITOS";

export const ALIAS_DETAIL_INTERNET = "mis-productos-internet";
export const ALIAS_DETAIL_SEGUNDA_FIBRA = "mis-productos-segunda-fibra";
export const ALIAS_DETAIL_FIBRA_ADICIONAL = "mis-productos-fibra-adicional";
export const ALIAS_DETAIL_LINEA_FIJA = "mis-productos-fijo";
export const ALIAS_DETAIL_LINEA_MOVIL = "mis-productos-linea-movil";
export const ALIAS_DETAIL_TV = "mis-productos-tv";
export const ALIAS_DETAIL_TV_MIMO = "mis-productos-tv-mimo";
export const ALIAS_DETAIL_USAGES = "mis-productos-consumos";
export const ALIAS_DETAIL_DEVICES = "mis-dispositivos";
export const ALIAS_DETAIL_SALUD = "mis-productos-salud";
export const ALIAS_DETAIL_GAME_PASS = "mis-productos-game-pass";
export const ALIAS_DETAIL_SECURITY = "mis-productos-alarmas";
export const ALIAS_DETAIL_CAR = "mis-productos-car";
export const ALIAS_DETAIL_SEGURO_MOVIL = "mis-productos-seguro-movil";
export const ALIAS_DETAIL_MIS_PRODUCTOS = "mis-productos";

export const ALIAS_SKYSHOWTIME_ACTIVATION = "activacion-skyshowtime";
export const ALIAS_HBO_MAX_ACTIVATION = "activacion-hbo";
export const ALIAS_DISNEY_ACTIVATION = "activacion-disney";
export const ALIAS_DAZN_ACTIVATION = "activacion-dazn";
export const ALIAS_MIS_PRODUCTOS = "mis-productos";
export const ALIAS_FACTURAS = "facturas";
export const ALIAS_ALERT_PAGO_DEUDA = "ap-pago-deuda";
export const ALIAS_DETALLE_FACTURAS = "detalle-facturas";
export const ALIAS_DETALLE_FACTURAS_PREPAGO = "detalle-facturas-prepago";
export const ALIAS_PERFIL_PASSWORD = "ap-perfil-password";
export const ALIAS_GESTIONES_LINEA_MOBIL_DETALLE = "ap-gestiones-linea-movil";
export const ALIAS_GESTIONES_LINEA_MOBIL_DETALLE_BUZON = "ap-gestiones-linea-movil-buzon";
export const ALIAS_GESTIONES_LINE_PHONE_DETALLE = "ap-gestiones-linea-fija";

export const ALIAS_GESTIONES_GLOBAL = "gestiones-tv";

export const ALIAS_MODAL_APPLE_TV = "ap-modal-apple-tv";
export const ALIAS_MODAL_FLIXOLE = "ap-modal-flixole";
export const ALIAS_MODAL_SKYSHOWTIME = "ap-modal-skyshowtime";
export const ALIAS_ACTIVACION_PERPLEXITY = "activacion-perplexity";
export const ALIAS_ACTIVACION_CHATGPT = "activacion-chatgpt";

export const ALIAS_E_SIM = "esim";
export const ALIAS_ESIM_HOME = "ap-esim";

export const ALIAS_AUTODIAGNOSTICO = "autodiagnostico";
export const ALIAS_AUTODIAGNOSTICO_CODE = "autodiagnostico-code";

export const BILLS_MANAGMENTS = "gestiones-de-factura";
export const PROFILE_MANAGMENTS = "gestiones-datos-personales";
export const ALIAS_CARDS_EQUIPMENT = "ap-list-card";
export const SWAP_LEGALS = "ap-condiciones-renovacion";

export const ALIAS_CERBERUS = "ap-perfil-proteccion-llamadas";
export const ALIAS_CERBERUS_SUMMARY = "ap-info-amenazas";

export const FAST_PASS = "ap-movistar-fast";

export const MODULO_BUYBOX_CARACTERISTICS_ACTIVACION_SKYSHOWTIME_CREA =
  "MODULO_BUYBOX_CARACTERISTICS_ACTIVACION_SKYSHOWTIME_CREA";
export const MODULO_FAQS_ACTIVACION_SKYSHOWTIME_CREA =
  "MODULO_FAQS_ACTIVACION_SKYSHOWTIME_CREA";
export const MODULO_BUYBOX_CARACTERISTICS_CUENTA_CREADA_SKYSHOWTIME =
  "MODULO_BUYBOX_CARACTERISTICS_CUENTA_CREADA_SKYSHOWTIME";
export const MODULO_BUYBOX_CARACTERISTICS_SIN_CUENTA_SKYSHOWTIME =
  "MODULO_BUYBOX_CARACTERISTICS_SIN_CUENTA_SKYSHOWTIME";
export const MODULO_FAQS_CUENTA_CREADA_SKYSHOWTIME_CREA =
  "MODULO_FAQS_CUENTA_CREADA_SKYSHOWTIME_CREA";

export const MODULO_BUYBOX_CARACTERISTICS_ACTIVACION_HBO_CREA =
  "MODULO_BUYBOX_CARACTERISTICS_ACTIVACION_HBO_CREA";
export const MODULO_FAQS_ACTIVACION_HBO_CREA =
  "MODULO_FAQS_ACTIVACION_HBO_CREA";
export const MODULO_BUYBOX_CARACTERISTICS_CUENTA_CREADA_HBO =
  "MODULO_BUYBOX_CARACTERISTICS_CUENTA_CREADA_HBO";
export const MODULO_BUYBOX_CARACTERISTICS_SIN_CUENTA_HBO =
  "MODULO_BUYBOX_CARACTERISTICS_SIN_CUENTA_HBO";

export const MODULO_BUYBOX_CARACTERISTICS_ACTIVACION_DISNEY_CREA =
  "MODULO_BUYBOX_CARACTERISTICS_ACTIVACION_DISNEY_CREA";
export const MODULO_FAQS_ACTIVACION_DISNEY_CREA =
  "MODULO_FAQS_ACTIVACION_DISNEY_CREA";
export const MODULO_BUYBOX_CARACTERISTICS_CUENTA_CREADA_DISNEY =
  "MODULO_BUYBOX_CARACTERISTICS_CUENTA_CREADA_DISNEY";
export const MODULO_FAQS_CUENTA_CREADA_DISNEY =
  "MODULO_FAQS_CUENTA_CREADA_DISNEY";
export const MODULO_BUYBOX_CARACTERISTICS_SIN_CUENTA_DISNEY =
  "MODULO_BUYBOX_CARACTERISTICS_SIN_CUENTA_DISNEY";

export const MODULO_BUYBOX_CARACTERISTICS_ACTIVACION_DAZN_CREA =
  "MODULO_BUYBOX_CARACTERISTICS_ACTIVACION_DAZN_CREA";
export const MODULO_FAQS_ACTIVACION_DAZN_CREA =
  "MODULO_FAQS_ACTIVACION_DAZN_CREA";
export const MODULO_BUYBOX_CARACTERISTICS_CUENTA_CREADA_DAZN =
  "MODULO_BUYBOX_CARACTERISTICS_CUENTA_CREADA_DAZN";
export const MODULO_FAQS_CUENTA_CREADA_DAZN = "MODULO_FAQS_CUENTA_CREADA_DAZN";
export const MODULO_BUYBOX_CARACTERISTICS_SIN_CUENTA_DAZN =
  "MODULO_BUYBOX_CARACTERISTICS_SIN_CUENTA_DAZN";

export const AP_PRODUCT_CONTRATADOS_LIST_DISPOSITIVOS = "AP_PRODUCTOS_CONTRATADOS_DISPOSITIVOS";
export const AP_PRODUCT_CONTRATADOS_LIST_TELEVISION = "AP_PRODUCTOS_CONTRATADOS_TELEVISION";

export const shouldRenderOrionInfo = (orionInfo, alias, index, property) => {
  return (
    orionInfo &&
    Array.isArray(Object.keys(orionInfo)) &&
    Object.keys(orionInfo).length > 0 &&
    Object.keys(orionInfo).includes(alias) &&
    Array.isArray(orionInfo[alias]) &&
    orionInfo[alias].length > index &&
    orionInfo[alias][index] &&
    orionInfo[alias][index][property]
  );
};
